import React from 'react';
import { Progress, Typography, Space } from 'antd';
import { useAppSelector } from 'utilities/hooks';
import { formatBytes } from 'utilities/helpers';

const { Text } = Typography;

const STORAGE_LIMIT_THRESHOLD = 80;

const styles: { [key: string]: React.CSSProperties } = {
    container: {
        marginBottom: '16px',
        width: '100%',
    },
    alertContainer: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        flexDirection: 'row-reverse',
    },
    alertText: {
        fontSize: '12px',
        color: 'red',
    },
    headerText: {
        fontSize: '14px',
    },
    subtext: {
        fontSize: '12px',
        color: '#666',
    },
    headerContainer: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
    },
};

const StorageProgressBar: React.FC = () => {
    const storageSize = useAppSelector<{ size: number; limit: number } | null>((state) => state.documents.storageSize);

    if (!storageSize) {
        return null;
    }

    const { size, limit } = storageSize;
    const percentage = limit > 0 ? Math.round((size / limit) * 100) : 0;

    const getStatus = (): 'normal' | 'exception' => {
        if (percentage >= STORAGE_LIMIT_THRESHOLD) return 'exception';
        return 'normal';
    };

    return (
        <Space direction="vertical" style={styles.container}>
            <div style={styles.headerContainer}>
                <Text strong style={styles.headerText}>
                    Storage Usage
                </Text>
                <Text style={styles.subtext}>
                    {formatBytes(size)} / {formatBytes(limit)} ({percentage}% used)
                </Text>
            </div>
            <div>
                <Progress percent={percentage} status={getStatus()} showInfo={false} />
                <div style={styles.alertContainer}>
                    {percentage >= STORAGE_LIMIT_THRESHOLD && (
                        <Text style={styles.alertText}>
                            {percentage >= 100 ? 'Storage limit reached' : 'Storage limit nearly reached'}
                        </Text>
                    )}
                </div>
            </div>
        </Space>
    );
};

export default StorageProgressBar;
